<template>
  <div class="cbaas-search-wrap">
    <el-input v-model="inputValue" :placeholder="placeholder" :disabled="disabled" clearable @blur="onBlur" @keyup.enter.native="onSearch">
    </el-input>
    <el-button :disabled="disabled" @click="onSearch()">
      <span :class="['iconfont', 'icon-search', 'btn-icon']"></span>
    </el-button>
  </div>
</template>

<script>
export default {
  name: 'Search',
  props: {
    value: {
      type: String,
      default: () => {
        return ''
      }
    },
    placeholder: {
      type: String,
      default: '输入区块Hash/区块高度/交易ID/合约名称搜索'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      inputValue: ''
    }
  },
  watch: {
    value: {
      handler(val, oldval) {
        this.inputValue = val
      },
      deep: true
    }
  },
  mounted() { },
  methods: {
    onBlur() {
      this.$emit('input', this.inputValue)
    },
    onSearch() {
      this.$emit('input', this.inputValue)
      this.$emit('onSearch', this.inputValue)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
@include theme('cbaas-search-wrap', (
  --cbaas-search-input-bg: #152341,
  --cbaas-search-input-border: rgba(69, 194, 255, 0.5),
  --cbaas-search-input-color: #fff,
  --cbaas-search-input-placeholder-color: #517080,
  --cbaas-search-button-bg: #45c2ff,
  --cbaas-search-button-color: #fff,
), (
  --cbaas-search-input-bg: #fff,
  --cbaas-search-input-border: #ebebeb,
  --cbaas-search-input-color: #122836,
  --cbaas-search-input-placeholder-color: #c4c5c6,
  --cbaas-search-button-bg: #45c2ff,
  --cbaas-search-button-color: #fff,
));
.cbaas-search-wrap {
  @include adaptation(
    (
      --cbaas-search-width: 253px,
      --cbaas-search-height: 32px,
      --cbaas-search-margin-right: 12px,
      --cbaas-search-border-radius: 4px,
      --cbaas-search-border-width: 1px,
      --cbaas-search-input-height: 32px,
      --cbaas-search-input-fontsize: 12px,
      --cbaas-search-btn-border-radius: 4px,
      --cbaas-search-btn-width: 32px,
      --cbaas-search-btn-height: 32px,
      --cbaas-search-btn-padding: 8px,
      --cbaas-search-btn-fontsize: 16px,
      --cbaas-search-input-suffix-width: 32px,
      --cbaas-search-input-suffix-fontsize: 16px
    )
  );
  width: var(--cbaas-search-width);
  height: var(--cbaas-search-height);
  margin-right: var(--cbaas-search-margin-right);
  display: flex;
  border-radius: var(--cbaas-search-border-radius);
  border: var(--cbaas-search-border-width) solid var(--cbaas-search-input-border);
  background: var(--cbaas-search-input-bg);

  .el-input {
    margin-top: calc(0px - var(--cbaas-search-border-width));
    height: var(--cbaas-search-input-height);
    font-size: var(--cbaas-search-input-fontsize);
    font-style: normal;
    font-weight: 400;
    line-height: normal;

    /deep/ .el-input__inner {
      height: var(--cbaas-search-input-height);
      line-height: var(--cbaas-search-input-height);
      border: none;
      background: transparent;
      color: var(--cbaas-search-input-color);

      &::placeholder {
        color: var(--cbaas-search-input-placeholder-color);
      }
    }

    /deep/ .el-input__suffix {
      right: 0;

      .el-input__suffix-inner {
        .el-input__icon {
          width: var(--cbaas-search-input-suffix-width);
          color: var(--cbaas-search-input-color);
          line-height: var(--cbaas-search-height);
          font-size: var(--cbaas-search-input-suffix-fontsize);
        }
      }
    }
  }

  .el-button {
    width: var(--cbaas-search-btn-width);
    height: var(--cbaas-search-btn-height);
    padding: var(--cbaas-search-btn-padding);
    border: none;
    margin-top: calc(0px - var(--cbaas-search-border-width));
    margin-right: calc(0px - var(--cbaas-search-border-width));
    border-radius: var(--cbaas-search-btn-border-radius);
    background: var(--cbaas-search-button-bg);

    .btn-icon {
      font-size: var(--cbaas-search-btn-fontsize);
      color: var(--cbaas-search-button-color);
    }
  }

  .el-button:hover {
    opacity: 0.8;
  }
}
</style>
